





































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad } from '@/http';
import { NumberKeyboard } from "@/components";
import { Toast } from 'vant';
var md5 = require("js-md5");
@Component({ 
    components: {
        NumberKeyboard
    },
})
export default class mmSetting extends Vue {
   
    public $refs: {
    };

    //  登录信息
    loginInfo = {}
    form:any={
        oldpwd:'',
        newpwd:'',
        repeatpwd:''
    };

    isLoading= false;

    created() {
        this.loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
    }

    async mounted(){
    }
    async saveEdit(){
        if(this.isLoading) return;
        if(!this.form.oldpwd){
            Toast('请输入原始密码');
            return;
        }
        if(!this.form.newpwd){
            Toast('请输入新密码');
            return;
        }
        if(!this.form.repeatpwd){
            Toast('请输入重复新密码');
            return;
        }
        if (this.form.newpwd && !/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,16}$/.test(this.form.newpwd)) {
            Toast("新密码长度为8-16位，且必须同时包含数字、大小写字母");
            return;
        }
        if(this.form.repeatpwd!=this.form.newpwd) {
            Toast('重复新密码与新密码不一致');
            return;
        }
        if(this.form.oldpwd!=this.loginInfo['pwd']) {
            Toast('原始密码输入不正确');
            return;
        }
        this.isLoading = true;
        console.log('this,.',this.form);
        try {
            let res= await TbShopAccount.UpdateTbShopAccount({
                id:this.loginInfo['id'],
                name:this.loginInfo['name'],
                phone:this.loginInfo['phone'],
                pwd:md5(this.form.newpwd),
                roleId:this.loginInfo['roleId']
            })
            Toast('修改密码成功');
            localStorage.removeItem("padUserinfo");
            localStorage.removeItem("padToken");
            this.$router.push("/pad/padLogin2");
            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/mmSetting.vue